import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import CenteredTabs from '../components/CenteredTabs';
import TweetButton from '../components/tweetbutton'

class User extends Component{

  render(){

    return(<main>
      <Grid container>
        <Grid item xs={12}>
          <CenteredTabs/>
          <TweetButton/>
        </Grid>
      </Grid>
    </main>)
  }
}

export default User;
